import { render, staticRenderFns } from "./ViewQuackReport.vue?vue&type=template&id=35ff4832&scoped=true"
import script from "./ViewQuackReport.vue?vue&type=script&lang=js"
export * from "./ViewQuackReport.vue?vue&type=script&lang=js"
import style0 from "./ViewQuackReport.vue?vue&type=style&index=0&id=35ff4832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff4832",
  null
  
)

export default component.exports